import { render, staticRenderFns } from "./ProjectTeamMember.vue?vue&type=template&id=6ba9e02d"
import script from "./project-team-member.ts?vue&type=script&lang=ts&external"
export * from "./project-team-member.ts?vue&type=script&lang=ts&external"
import style0 from "./project-team-member.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports